module.exports = __webpack_public_path__ + "static/media/ic_graphic_coming_soon@2x.dfb6b299.png";